import { useContext } from 'react';
import { DatasetFormDataContext } from '../../context/DatasetFormDataContext/DatasetFormDataContext';
import { FilterError } from '../../types/types';
import { UseDatasetFormInputDataReturnType } from '../../types/context';

export const useDatasetFormInputData = (
  name: string
): UseDatasetFormInputDataReturnType => {
  const context = useContext(DatasetFormDataContext);

  if (context.isProvided === false) {
    throw new Error(
      'useDatasetFormInputData must be used within a DatasetFormDataContextProvider'
    );
  }

  return {
    isProvided: context.isProvided,
    dataset: context.dataset,
    form: context.form,
    value: context.formData?.[name],
    error: context.formErrors?.[name],
    setError: (error: FilterError) =>
      context.setFormErrors((state) => ({ ...state, [name]: error })),
    handleInputChange: context.handleInputChange,
  };
};
